export default __webpack_public_path__ + "static/media/air.17054492.webp";